module.exports = __webpack_public_path__ + "src/img/sketchrunner/medium-screenshot.5aae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sketchrunner/medium-screenshot.png
// module id = 257
// module chunks = 0